import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { supportUrl } from 'Config/lang';
import drmSupportLink from 'Helpers/Order/SupportLink';

export default function RedeemSupport({
  drmPlatform,
  ubisoftSKA,
  epicSKA,
  bundleID,
  supportLink,
  game,
}) {
  let supportRef = `${supportUrl()}/articles/${drmSupportLink(drmPlatform, ubisoftSKA, epicSKA, bundleID, game)}`;
  if (supportLink.length > 0) {
    supportRef = supportLink;
  }

  let Text = null;

  switch (drmPlatform) {
    case 'coupon':
      Text = <FormattedMessage id="redeem-support.how-to-coupon" defaultMessage="How Do I use my Coupon?" />;
      break;
    case 'redeem':
      Text = <FormattedMessage id="redeem-support.how-to-redeem-code" defaultMessage="How Do I use my Redeem Code?" />;
      break;
    case 'drm_free':
      Text = <FormattedMessage id="redeem-support.book-support-link" defaultMessage="How do I download and view my files?" />;
      break;
    default:
      Text = <FormattedMessage id="redeem-support.how-to-redeem" defaultMessage="How Do I Redeem My Key?" />;
  }

  return (
    <div className="d-inline-flex">
      <a
        href={supportRef}
        className="text-primary redeem-help"
        target="_blank"
        rel="noopener noreferrer"
      >
        {Text}
      </a>
    </div>
  );
}

RedeemSupport.propTypes = {
  drmPlatform: PropTypes.string,
  ubisoftSKA: PropTypes.bool,
  epicSKA: PropTypes.bool,
  bundleID: PropTypes.string,
  supportLink: PropTypes.string,
  game: PropTypes.shape({}),
};

RedeemSupport.defaultProps = {
  drmPlatform: '',
  ubisoftSKA: false,
  epicSKA: false,
  bundleID: '',
  supportLink: '',
};
